import React from "react";
import EditProgram from "../edit-program/EditProgram";
import OrderConfigurations from "../order-configs/OrderConfigurations";
import CreateConfiguration from "../create-config/CreateConfiguration";
import SDCConfiguration from "../create-config/SDCConfiguration";
import G2S2Configuration from "../create-config/G2S2Configuration";
import AWSAppConfiguration from "../create-config/AWSAppConfiguration";
import UpdateConfiguration from "../update-config/UpdateConfiguration";
import Text from "@amzn/meridian/text";
import Link from "@amzn/meridian/link";
import '../program-launch-status/ProgramLaunchStatus.css'
import GrokConfiguration from "../create-config/GrokConfiguration";

export const NO_PERMISSION_ERROR =  "You're not authorised to access this page. Please review your permissions.";

export const DEFAULT_ROUTES = {
    "/manageprograms": "/manageprograms/editprogram",
    "/editprogram": "/manageprograms/editprogram",
    "/createconfig": "/manageprograms/createfeatures/",
    "/removeconfig": "/manageprograms/createfeatures/",
    "/orderconfigs": "/manageprograms/orderconfigs"
}

export const MANAGE_PROGRAMS_ROUTES = [
    {
        name: "Create/Edit Program",
        path: "/manageprograms/editprogram",
        id: "Create/Edit Program",
        component: (props) => {
            return (<EditProgram {...props} />)
        },
    },
    {
        name: "Create/Edit Features",
        path: "/manageprograms/createfeatures",
        id: "Create/Edit Features",
        component: (props) => {
            return (<UpdateConfiguration {...props} />)
        },
    },
    {
        name: "Order Configs",
        path: "/manageprograms/orderconfigs",
        id: "Order Configs",
        component: (props) => {
            return (<OrderConfigurations {...props} />)
        },
    }
]

export const CREATE_FEATURES_BASE_ROUTE = "manageprograms/createfeatures";

export const CREATE_FEATURES_SUB_ROUTES = {
    CREATE_CONFIG: "createconfig",
    SDC_CONFIG: "sdcconfig",
    G2S2_CONFIG: "g2s2config",
    AWS_APP_CONFIG: "awsappconfig",
    GROK_CONFIG: "grokconfig"
}

export const EDIT_CONFIGURATION_ROUTES = [
    {
        name: "Edit Configuration",
        path: `/${CREATE_FEATURES_BASE_ROUTE}/${CREATE_FEATURES_SUB_ROUTES.CREATE_CONFIG}`,
        id: "Edit Configuration",
        component: (props) => {
            return (<CreateConfiguration {...props} />)
        },
    },
    {
        name: "SDC Configuration",
        path: `/${CREATE_FEATURES_BASE_ROUTE}/${CREATE_FEATURES_SUB_ROUTES.SDC_CONFIG}`,
        id: "SDC Configuration",
        component: (props) => {
            return (<SDCConfiguration {...props} />)
        },
    }
    ,{
        name: "GROK Configuration",
        path: `/${CREATE_FEATURES_BASE_ROUTE}/${CREATE_FEATURES_SUB_ROUTES.GROK_CONFIG}`,
        id: "Grok Configuration",
        component: (props) => {
            return (<GrokConfiguration {...props} />)
        },
    },
    {
        name: "G2S2 Configuration",
        path: `/${CREATE_FEATURES_BASE_ROUTE}/${CREATE_FEATURES_SUB_ROUTES.G2S2_CONFIG}`,
        id: "G2S2 Configuration",
        component: (props) => {
            return (<G2S2Configuration {...props} />)
        },
    },
    {
        name: "AWS App Configuration",
        path: `/${CREATE_FEATURES_BASE_ROUTE}/${CREATE_FEATURES_SUB_ROUTES.AWS_APP_CONFIG}`,
        id: "AWS App Configuration",
        component: (props) => {
            return (<AWSAppConfiguration {...props} />)
        },
    }
]

function getLaunchStatusInfo() {
    return (
        <div>
            <Text id = "LaunchStatusInfoText" >This feature is in beta phase. If you face any data discrepancy issues, please cut a SIM here : </Text>
            <Link id = "LaunchStatusInfoLink"href= "https://tiny.amazon.com/ly3xl1m6/issuamazfoldUTRProbFMC79f0" type="primary"> SIM Folder </Link>
        </div>
    )
}

export const PAGE_HEADERS = {
    MANAGE_PROGRAMS: {
        head: "managePrograms.heading",
        headAlt: "Manage Programs",
        desc: "managePrograms.description",
        descAlt: "This is for managing the existing programs or create new programs and the associated features.",
        info: "managePrograms.alert",
        infoAlt: "Any changes made to this page will be applicable across region but not specific to a station."
    },
    ENABLE_PROGRAM: {
        head: "enableProgram.heading",
        headAlt: "Enable Program",
        desc: "enableProgram.description",
        descAlt: "This is for launching a program on a station.",
        info: "enableProgram.alert",
        infoAlt: "Changes made for the given program will reflect on the selected station."
    },
    PROGRAM_LAUNCH_STATUS: {
        head: "programLaunchStatus.heading",
        headAlt: "Program Launch Status Summary",
        desc: "programLaunchStatus.description",
        descAlt: "This is for viewing Program Launch status for the selected Root Station",
        info: "programLaunchStatus.alert",
        infoAlt: getLaunchStatusInfo()

    }
}


// WEBPACK FOOTER //
// ./src/components/util/RouteConstants.js